import { createOutlookAddinEnvironment, EnvNames } from '@pinnakl/core/environment';

export const environment = createOutlookAddinEnvironment(EnvNames.dev);
